import React from "react";
import {AuthContext} from "../Context/RootContext";
import useProgress from "./useProgress";
import Constants from "../Configuration";
import {RequestType} from "../Services/ApiService";

const useSubscriptionApiService = () => {
    const {error, isLoading, BeginLoading} = useProgress();
    const state = React.useContext(AuthContext);

    const claimFreeSubscription = () => BeginLoading(async () => {
        const response = await state.apiService.callApi(Constants.apiEndpoint + "Subscribe/free", undefined, RequestType.POST);
        return response.data;
    });

    return {claimFreeSubscription, isLoading, error};
}

export default useSubscriptionApiService;
